export enum SmsFieldType {
  CONTACT_FIELD = 'CONTACT_FIELD',
  INDEX_FIELD = 'INDEX_FIELD',
}
